// Utility functions for resource file/image/tag handling

export function generateNameFromFile(filename) {
  if (filename) {
    let part = filename.split(".");
    return part[0]
      .replace(/[^a-zA-Z ]/g, " ")
      .replace(/  +/g, " ")
      .trim();
  } else {
    return "";
  }
}

export function removePreview(selectedFile, mainImage, filename, tempPreviewRef) {
  const tempMainImage = selectedFile[mainImage];
  tempPreviewRef.current = [
    ...tempPreviewRef.current.filter((item) => item.filename !== filename),
  ];
  const removedPreview = selectedFile.filter(
    (item) => item.filename !== filename
  );
  const indexMainImage = removedPreview.findIndex(
    (item) => item.filename === tempMainImage.filename
  );
  return { removedPreview, indexMainImage };
}

export async function handlePreview(files, tempPreviewRef, selectedFile, previewProcess) {
  let tempResult = [];
  let filtedFiles = [];
  if (tempPreviewRef.current) {
    filtedFiles = [...files].filter(
      (obj1) => !tempPreviewRef.current.some((obj2) => obj1.name === obj2.name)
    );
    tempPreviewRef.current = [...tempPreviewRef.current, ...filtedFiles];
  } else {
    filtedFiles = [...files];
    tempPreviewRef.current = [...files];
  }
  if (filtedFiles.length) {
    await Promise.all(
      filtedFiles.map(async (file) => {
        const formData = new FormData();
        formData.append("data", file);
        const { data } = await previewProcess(formData);
        if (data) {
          tempPreviewRef.current.map((item) => {
            if (item.name === file.name) {
              item.filename = data.detail.filename;
              return item;
            } else {
              return item;
            }
          });
          const newPreview = {
            filename: data.detail.filename,
            sizes: [
              {
                size: "original",
                path: data.detail.original.path,
                contentType: data.detail.original.contentType,
                width: data.detail.original.width,
                height: data.detail.original.height,
              },
            ],
          };
          if (data.detail.thumbnail) {
            newPreview.sizes.push({
              size: "small",
              path: data.detail.thumbnail.path,
              contentType: data.detail.thumbnail.contentType,
              width: data.detail.thumbnail.width,
              height: data.detail.thumbnail.height,
            });
          }
          tempResult.push(newPreview);
        }
      })
    );
    return [...selectedFile, ...tempResult];
  }
  return selectedFile;
}
